module.exports = __webpack_public_path__ + "img/icn_open.dca45e1e.svg";